import ErrorIcon from '@mui/icons-material/Error';
import { format } from 'date-fns';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import routes from '../../config/routes';
import { MissingCauses } from '../../types';
import { MissingDialogPayload } from './types';

interface CausesButtonProps {
  viewMode: string;
  country: string;
  store: string;
  date: Date;
  cause: MissingCauses;
  onOpenModal?: (payload: MissingDialogPayload) => void;
}

const CausesButton = ({
  viewMode,
  country,
  store,
  date,
  cause,
  onOpenModal,
}: CausesButtonProps) => {
  const navigate = useNavigate();

  const handleClickApply = useCallback(() => {
    const isErrorModal = [
      MissingCauses.CLOSING_NOT_INFORMED,
      MissingCauses.SALES_CLOSING_NOT_INFORMED,
      MissingCauses.COLL_CLOSING_NOT_INFORMED,
    ].includes(cause);

    if (onOpenModal) {
      onOpenModal({
        type: isErrorModal ? 'error' : 'causes',
        viewMode,
        country,
        store,
        date,
        cause,
      });
      return;
    }

    if (isErrorModal) {
      navigate({
        pathname: routes.protectedNestedRoutes.missingClosingDetail.children.errors.path,
        search: `viewMode=${viewMode}&country=${country}&store=${store}&date=${format(
          date,
          'yyyy-MM-dd'
        )}&cause=${cause}`,
      });
      return;
    }

    navigate(
      `${
        routes.protectedNestedRoutes.missingClosingDetail.children.causes.path
      }?viewMode=${viewMode}&country=${country}&store=${store}&date=${format(
        date,
        'yyyy-MM-dd'
      )}&cause=${cause}`
    );
  }, [cause, country, date, navigate, onOpenModal, store, viewMode]);

  return <ErrorIcon color="error" onClick={handleClickApply} cursor="pointer" />;
};

export default CausesButton;
